import React, { FC } from 'react'

const NOTIFICATION_STYLE: React.CSSProperties = {
  color: 'white',
  background: '#AF231C',
  borderRadius: '2px',
  padding: '2px 4px',
  marginLeft: '10px',
  fontSize: '14px',
  lineHeight: '16px',
  marginRight: '4px'
}

const Notifications: FC<{
  notificationCount: number
}> = ({ notificationCount }): JSX.Element => {
  return <span style={NOTIFICATION_STYLE}>{`${notificationCount}`}</span>
}

export default Notifications
